function ProductReducer(state = { productBugList: [], selectBugModalStatus: '', 
productMainGroupList: [], productGroupList:[], defaultStorages:{} }, action) {
    switch (action.type) {
        case "SEARCH_PRODUCT_BUG":
            return {
                ...state,
                productBugList: action.data
            }
        case "SET_PBUG_POP":
            return {
                ...state,
                selectBugModalStatus: action.data
            }
        case "GET_PRODUCT_MAINGROUPS":
            return {
                ...state,
                productMainGroupList: action.data
            }
        case "GET_PRODUCT_GROUPS":
            return {
                ...state,
                productGroupList: action.data
            }
            case "DEFAULT_STORAGES":
                return{
                    ...state,
                    defaultStorages:action.data
                }
        default:
            return state;
    }
}
export default ProductReducer;